import { render, staticRenderFns } from "./GameEnded.vue?vue&type=template&id=0219ba28&scoped=true&"
import script from "./GameEnded.vue?vue&type=script&lang=js&"
export * from "./GameEnded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0219ba28",
  null
  
)

export default component.exports